import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import VideoRecorder from 'react-video-recorder';
import Alert from '../notification/Alert';

const RenderVideoRecorder = (props) => {
    const {
        meta: { touched, error },
        videoChangedHandler,
    } = props;
    
    return (
        <div className="form__form-group-input-wrap">
            <VideoRecorder
                renderDisconnectedView={() => (
                    <div className='background-black' />
                )}
                onRecordingComplete={(videoBlob) => {
                    videoChangedHandler(videoBlob);
                }}
                replayVideoAutoplayAndLoopOff={false}
                timeLimit={4000}
                showReplayControls
                constraints={{ audio: false, video: true }}
                isFlipped
            />
            {touched && error && (
                <Alert color="danger" className="alert--colored" icon>
                    <p className="margin-top-10">{error}</p>
                </Alert>
            )}
        </div>
    );
};

RenderVideoRecorder.defaultProps = {
    meta: {
        touched: false,
        error: '',
    },
};

export default RenderVideoRecorder;
